import React from 'react';
import type { Icon } from './types';

export const HeartFilled: Icon = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="50.6207 14.173 18.3338 17.5"
            width="18.3338px"
            height="17.5px"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M 60.374 19.625 C 60.149 20.134 59.427 20.134 59.201 19.625 L 58.263 17.51 C 57.83 16.531 56.821 15.84 55.554 15.84 C 54.666 15.84 53.709 16.197 53.035 16.987 C 52.299 17.85 52.076 19.05 52.504 20.144 C 52.799 20.897 53.342 21.736 53.792 22.391 C 54.823 23.887 56.59 25.893 58.154 27.574 C 58.76 28.227 59.325 28.818 59.788 29.295 C 60.25 28.818 60.815 28.227 61.421 27.574 C 62.985 25.893 64.752 23.887 65.783 22.391 C 66.234 21.736 66.776 20.897 67.071 20.144 C 67.5 19.05 67.276 17.85 66.54 16.987 C 65.867 16.197 64.91 15.84 64.021 15.84 C 62.755 15.84 61.745 16.531 61.312 17.51 L 60.374 19.625 Z"
                transform="matrix(1, 0, 0, 1, 0, 7.105427357601002e-15)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M 60.956 30.485 C 60.65 30.801 60.389 31.066 60.193 31.265 C 59.936 31.526 59.788 31.673 59.788 31.673 C 59.788 31.673 59.639 31.526 59.382 31.265 C 59.186 31.066 58.925 30.801 58.619 30.485 C 56.965 28.777 53.97 25.588 52.42 23.336 C 51.968 22.68 51.324 21.701 50.952 20.752 C 50.294 19.072 50.642 17.226 51.767 15.906 C 52.796 14.698 54.24 14.173 55.554 14.173 C 56.771 14.173 57.877 14.607 58.702 15.345 C 59.161 15.755 59.533 16.26 59.788 16.836 C 60.042 16.26 60.414 15.755 60.873 15.345 C 61.698 14.607 62.804 14.173 64.021 14.173 C 65.335 14.173 66.78 14.698 67.809 15.906 C 68.934 17.226 69.281 19.072 68.623 20.752 C 68.251 21.701 67.607 22.68 67.155 23.336 C 65.605 25.588 62.61 28.777 60.956 30.485 Z"
                transform="matrix(1, 0, 0, 1, 0, 7.105427357601002e-15)"
            />
        </svg>
    );
};
